// Simple pub-sub store for the current scan flow.
let _state = {
  currentPhoto: null,
  currentAnalysis: null,
};
const _subs = new Set();

export const scanStore = {
  get: () => _state,
  set: (patch) => {
    _state = { ..._state, ...patch };
    _subs.forEach((cb) => cb(_state));
  },
  subscribe: (cb) => {
    _subs.add(cb);
    return () => _subs.delete(cb);
  },
  reset: () => scanStore.set({ currentPhoto: null, currentAnalysis: null }),
};
